import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoDescriptIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoDescript",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.412 11.445c0-1.43-.904-2.334-2.334-2.334H2.409v4.668h4.669c1.43 0 2.334-.904 2.334-2.334M13.742 0H5.307C3.538 0 2.41 1.13 2.41 2.899v1.807h23.266C22.852 1.694 18.748 0 13.741 0m.338 11.445c0 1.43.904 2.334 2.334 2.334h13.177c-.189-1.694-.565-3.238-1.13-4.668H16.414c-1.43 0-2.334.94-2.334 2.334m7.002 9.11c0 1.43.904 2.334 2.334 2.334h5.045c.565-1.43.941-2.974 1.13-4.668h-6.175c-1.43 0-2.334.941-2.334 2.334m-4.668 0c0-1.43-.904-2.334-2.334-2.334H2.41v4.668h11.67c1.43 0 2.334-.903 2.334-2.334M2.41 29.101c0 1.77 1.13 2.899 2.9 2.899h8.432c5.045 0 9.148-1.694 11.934-4.668H2.41z"
    })
  }));
};
LogoDescriptIcon.displayName = 'LogoDescriptIcon';